import axios from 'axios'

// var callback;

var http = axios.create({
  baseURL: process.env.API_BASE_URL + '/itembank',
  headers: {'Content-Type': 'application/json'},
})

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function getVideoDetail(id, callback) {
  var config = getConfig()
  http.get('/video_info?source=youtube&video_id='+ id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    alert('error')
    callback({
      success: false,
      message: error.message
    })

  })
}

function getVideoDetailById(id, callback) {
  var config = getConfig()
  http.get('/video/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function getListVideo(callback)
{
  var config = getConfig()
  http.get('/videos', config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListVideoByModuleId(moduleId, callback)
{
  var config = getConfig()
  http.get('/videos?module_id='+moduleId, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListVideoLiveStreamByModuleId(moduleId, callback)
{
  var config = getConfig()
  http.get('/streamings?module_id='+moduleId, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function deleteVideo(id, callback)
{
  var config = getConfig()
  http.delete('/video/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function addVideo(dataBody, callback)
{
  var config = getConfig()

  http.post('/video', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function addVideoLiveStreaming (dataBody, callback)
{
  var config = getConfig()

  http.post('/streaming', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}

function editVideo(id,dataBody, callback)
{
  var config = getConfig()
  http.put('/video/' + id,dataBody, config).then(function(response) {
    alert('ubah data berhasil')
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    alert('error')
    callback({
      success: true,
      message: error.message
    })
  })
}
function editVideoLiveStreaming (id,dataBody, callback)
{
  var config = getConfig()
  http.put('/streaming/' + id,dataBody, config).then(function(response) {
    alert('ubah data berhasil')
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    alert('error')
    callback({
      success: true,
      message: error.message
    })
  })
}

function deleteVideoStreaming (id, callback)
{
  var config = getConfig()
  http.delete('/streaming/' + id, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

function setPublishing (id, dataBody, callback)
{
  var config = getConfig()
  http.put('/streaming/' + id + '/publish', dataBody, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: true,
      message: error.message
    })
  })
}

export default
{
    getVideoDetail,
    getListVideo,
    deleteVideo,
    addVideo,
    getVideoDetailById,
    editVideo,
    getListVideoByModuleId,
    getListVideoLiveStreamByModuleId,
    addVideoLiveStreaming,
    deleteVideoStreaming,
    editVideoLiveStreaming,
    setPublishing
}



// WEBPACK FOOTER //
// ./src/services/video.js